import React from 'react';
import { Box, Text } from '@rsos/components/capstone/base';
import { ModalHeader } from '@rsos/components/capstone/base/Modal/ModalComponents';
import { Link } from '../Modal.styles';

export const ModalHeaders = ({ selected, handleCloseModal, partner }) => {
  return selected ? (
    <ModalHeader onClose={handleCloseModal}>
      <Box mb="12px">
        <Text size="xlarge" color="primaryText" fontWeight="bold">
          Enter the Credential Details
        </Text>
        <Text size="xlarge" color="primaryText">
          Provided by {partner && (partner.name || partner.data_source)}
        </Text>
      </Box>
      <Box width={250}>
        <Text color="secondaryText" size="normal" inline>
          <Text color="primaryBase" inline fontWeight="bold">
            <Link
              padding="0"
              target="_blank"
              href={partner && partner.support_url}
            >
              Click here
            </Link>
          </Text>
          &nbsp;to learn about accessing{' '}
          {partner && (partner.name || partner.data_source)}’s Credential
          Details.
        </Text>
      </Box>
    </ModalHeader>
  ) : (
    <ModalHeader onClose={handleCloseModal}>
      <Box mb="12px" inline horizontal>
        <Text size="xlarge" color="primaryText" inline>
          Select a
        </Text>
        <Text size="xlarge" color="primaryText" fontWeight="bold" inline>
          &nbsp;Data Source
        </Text>
      </Box>
      <Box>
        <Text color="secondaryText" size="normal">
          This will be the Data Source for the Credential you will add.
        </Text>
      </Box>
    </ModalHeader>
  );
};
